<template>
  <div>
    <common-table
      :table-columns="tableColumns"
      :url="url"
      :operate="operate"
      :form-fields="formFields"
      :permission="permission"
      :searchs="searchs"
    ></common-table>
    <div class="dialog">
      <el-dialog
        :title="roleVisibleTitle"
        @close="resetForm()"
        :visible.sync="roleVisible"
        custom-class="common-dialog"
        :close-on-click-modal="false"
      >
        <div class="fc_dialog_body">
          <el-form ref="menuForm">
            <el-form-item label="角色：">
              <el-select
                multiple
                v-model="roleIds"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in roles"
                  :key="item.id"
                  :label="item.roleName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="roleVisible = false">取 消</el-button>
          <el-popconfirm :title="'确定更新？'" @onConfirm="updateRoles">
            <el-button
              slot="reference"
              size="small"
              type="primary"
              class="ml-10"
              >确 定</el-button
            >
          </el-popconfirm>
        </div>
      </el-dialog>
    </div>

    <div class="dialog">
      <el-dialog
        :title="siteVisibleTitle"
        @close="resetSiteForm()"
        :visible.sync="siteVisible"
        custom-class="common-dialog"
        :close-on-click-modal="false"
      >
        <div class="fc_dialog_body">
          <el-form ref="siteForm">
            <el-form-item label="网站：">
              <el-select
                multiple
                v-model="siteIds"
                clearable
                placeholder="请选择"
              >
                <el-option label="全部" value="0"></el-option>
                <el-option
                  v-for="item in sites"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="siteVisible = false">取 消</el-button>
          <el-popconfirm :title="'确定更新？'" @onConfirm="updateSites">
            <el-button
              slot="reference"
              size="small"
              type="primary"
              class="ml-10"
              >确 定</el-button
            >
          </el-popconfirm>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable/CommonTable'
export default {
  name: 'Admin',
  components: { CommonTable },
  data() {
    return {
      searchs: [
        {
          name: 'username',
          placeholder: '用户名',
          type: 'input',
        },
        {
          name: 'type',
          placeholder: '请选择类型',
          type: 'select',
          selectValue: [
            {
              key: 1,
              value: '管理员',
            },
            {
              key: 2,
              value: '代理商',
            },
          ],
        },
        {
          name: 'startTime',
          placeholder: '开始时间',
          type: 'dateTime',
        },
        {
          name: 'endTime',
          placeholder: '结束时间',
          type: 'dateTime',
        },
      ],
      permission: {
        add: 'admin:add',
        update: 'admin:update',
        delete: 'admin:delete',
        deleteBatch: 'admin:deleteBatch',
      },
      url: {
        get: '/adminInfo/listByCondition',
        add: '/adminInfo/add',
        update: '/adminInfo/update',
        delete: '/adminInfo/delete/',
        delete_batch: '/adminInfo/deleteBatch',
        status: '/adminInfo/status',
      },
      tableColumns: [
        {
          field: 'id',
          label: 'ID',
          show: true,
          width: '100',
        },/*{
          field: 'agentId',
          label: '代理',
          selectUrl: '/agent/getAll',
          selectData: [],
          show: {
            type: 'select',
          },
          detail: false,
          width: '',
        },*/
        {
          field: 'avatar',
          label: '头像',
          show: true,
          width: '75',
          img: true,
          avatar: true,
        },
        {
          field: 'username',
          label: '用户名',
          show: true,
          width: '',
        },
        {
          field: 'phone',
          label: '手机号',
          show: true,
          width: '',
        },
        {
          field: 'email',
          label: '邮箱',
          show: true,
          width: '',
        },
        {
          field: 'type',
          label: '类型',
          show: {
            type: 'tag',
            tags: [
              {
                key: 1,
                value: '管理员',
                type: 'success',
              },
              {
                key: 2,
                value: '代理商',
                type: 'primary',
              },
            ],
          },
          width: '90',
        },
        {
          field: 'loginTime',
          label: '登录时间',
          show: true,
          width: '',
        },
        {
          field: 'secretKey',
          label: '二维码',
          show: false,
          width: '85',
          img: true,
          qrCode: true,
        },
        {
          field: 'status',
          label: '状态',
          show: true,
          width: '90',
          status: true,
        },
        {
          field: 'inviteCode',
          label: '邀请码',
          show: false,
          width: '',
        },
      ],
      operate: [
        {
          icon: 'el-icon-edit',
          type: 'text',
          text: '重置密码',
          title: '确定重置该管理员密码？',
          handle: (row) => {
            const password = '123456'
            this.$axios.post({
              url: '/adminInfo/password/reset',
              data: { id: row.id, password: password },
              success: (res) => {
                if (res.code === 0) {
                  this.$message.success('密码重置成功')
                  //this.getData();
                } else {
                  this.$message.error('密码重置失败')
                }
              },
            })
          },
        },
        {
          icon: 'el-icon-edit',
          type: 'text',
          text: '角色',
          handle: (row) => {
            this.adminId = row.id
            this.getRoleData()
            this.getRoleIds(row.id)
            this.roleVisibleTitle = '[' + row.username + ']的角色'
            this.roleVisible = true
          },
/*          exist: () => {
            return this.$refs.table.havePermission('adminRole:update')
          }, */

        },
        {
          icon: 'el-icon-edit',
          type: 'text',
          text: '数据权限',
          handle: (row) => {
            this.adminId = row.id
            this.getSiteData()
            this.getSiteIds(row.id)
            this.siteVisibleTitle = '[' + row.username + ']的数据权限'
            this.siteVisible = true
          },
        },
        {
          icon: 'el-icon-edit',
          type: 'text',
          text: '踢下线',
          handle: (row) => {
            this.$axios.post({
              url: '/adminInfo/kickUser/' + row.id,
              confirm: '确定踢' + row.username + '下线',
              success: (res) => {
                if (res.code === 0) {
                  this.$message.success('操作成功')
                } else {
                  this.$message.error('获取数据错误')
                }
              },
              error: () => {
                this.$message.error('出错了')
              },
            })
          },
        },
      ],
      formFields: {
        addTitle: '添加管理员',
        updateTitle: '修改管理员',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules:[],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        },
          {
            field: 'username',
            label: '用户名：',
            type: 'input',
            placeholder: 'Username',
            rules: [
              {
                message: '请输入用户名',
                trigger: 'blur',
                required: true,
              },
              {
                max: 12,
                message: '用户名在12个字符内',
                trigger: 'blur',
                required: true,
              },
              {
                pattern: /^\S*$/,
                message: '用户名不能包含空格',
                trigger: 'blur',
                required: true,
              },
            ],
            add: true,
            update: true,
            onlyShow: true,
          },
          {
            field: 'password',
            label: '密码：',
            type: 'password',
            placeholder: 'Password',
            rules: [
              {
                message: '请输入密码',
                trigger: 'blur',
                required: true,
              },
              {
                min: 6,
                max: 18,
                message: '密码在6~18个长度内',
                trigger: 'blur',
                required: true,
              },
              {
                pattern: /^\S*$/,
                message: '密码不能包含空格',
                trigger: 'blur',
                required: true,
              },
            ],
            add: true,
            update: false,
          },
          {
            field: 'phone',
            label: '手机号：',
            type: 'number',
            maxlength: 11,
            placeholder: 'Phone',
            rules: [
              {
                message: '请输入手机号',
                trigger: 'blur',
                required: false,
              },
              {
                pattern: /^1[34578]\d{9}$/,
                message: '手机号格式错误',
                trigger: 'blur',
              },
            ],
            add: true,
            update: true,
          },
          {
            field: 'email',
            label: '邮箱：',
            type: 'input',
            placeholder: 'Email',
            rules: [
              {
                message: '请输入邮箱',
                trigger: 'blur',
                required: false,
              },
              {
                type: 'email',
                message: '邮箱格式错误',
                trigger: 'blur',
              },
            ],
            add: true,
            update: true,
          }, {
            field: 'inviteCode',
            label: '邀请码：',
            type: 'input',
            placeholder: '请输入邀请码,以英文“,”隔开',
            rules: [
            ],
            add: true,
            update: true,
          }
        ],
      },

      adminId: '',
      roleVisibleTitle: '',
      roleVisible: false,
      roles: [],
      roleIds: [],
      siteVisibleTitle: '',
      siteVisible: false,
      sites: [],
      siteIds: [],
    }
  },
  created() {},
  methods: {
    /*role(row){

            }*/

    /**
     * 获取所有角色
     */
    getRoleData() {
      this.$axios.post({
        url: '/role/all',
        success: (res) => {
          if (res.code === 0) {
            this.roles = res.data
          } else {
            this.$message.error('获取数据错误')
          }
        },
        error: () => {
          this.$message.error('出错了')
        },
      })
    },

    /**
     * 获取管理员角色ids
     * @param adminId
     */
    getRoleIds(adminId) {
      this.$axios.post({
        url: '/adminRole/roleIds/' + adminId,
        success: (res) => {
          if (res.code === 0) {
            this.roleIds = res.data
          } else {
            this.$message.error('获取数据错误')
          }
        },
        error: () => {
          this.$message.error('出错了')
        },
      })
    },

    /**
     * 修改管理员角色
     */
    updateRoles() {
      this.$axios.post({
        url: '/adminRole/update',
        data: { adminId: this.adminId, roleIds: this.roleIds },
        success: (res) => {
          if (res.code === 0) {
            this.$message.success('角色修改成功')
            this.roleVisible = false
          } else {
            this.$message.error('角色修改失败')
          }
        },
        error: () => {
          this.$message.error('出错了')
        },
      })
    },

    resetForm() {
      this.roleVisibleTitle = '管理员角色'
      this.roles = []
      this.roleIds = []
      this.adminId = ''
    },

    getSiteData() {
      this.$axios.post({
        url: '/siteInfo/getAll',
        success: (res) => {
          if (res.code === 0) {
            this.sites = res.data
          } else {
            this.$message.error('获取数据错误')
          }
        },
        error: () => {
          this.$message.error('出错了')
        },
      })
    },

    /**
     * 获取管理员数据ids
     * @param adminId
     */
    getSiteIds(adminId) {
      this.$axios.post({
        url: '/adminSite/siteIds/' + adminId,
        success: (res) => {
          if (res.code === 0) {
            if (res.data) {
              res.data.forEach((data) => {
                this.siteIds.push(data.siteId)
              })
            }

            //this.roleIds = res.data;
          } else {
            this.$message.error('获取数据错误')
          }
        },
        error: () => {
          this.$message.error('出错了')
        },
      })
    },

    /**
     * 修改管理员数据权限
     */
    updateSites() {
      this.$axios.post({
        url: '/adminSite/update',
        data: { adminId: this.adminId, siteIds: this.siteIds },
        success: (res) => {
          if (res.code === 0) {
            this.$message.success('数据权限修改成功')
            this.siteVisible = false
          } else {
            this.$message.error('数据权限修改失败')
          }
        },
        error: () => {
          this.$message.error('出错了')
        },
      })
    },

    resetSiteForm() {
      this.siteVisibleTitle = '管理员数据权限'
      this.sites = []
      this.siteIds = []
      this.adminId = ''
    },
  },
}
</script>

<style scoped>
</style>
